import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaSubcategory } from 'types/cms/collection-types'
import { stringify } from 'qs'

/**
 * Get the encyclopedia subcategory from the CMS for the given slug
 *
 * @param {string} slug
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaSubcategory | undefined>}
 */
const getEncyclopediaSubcategoryBySlug = async (
  slug: string,
  locale: Language = Language.DUTCH
): Promise<CmsEncyclopediaSubcategory | undefined> => {
  try {
    const query = stringify({
      locale
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaSubcategory>>(
      `${process.env.CMS_API_URL}/encyclopedia-sub-category/${slug}?${query}`
    )

    return data.data
  } catch (_) {
    return undefined
  }
}

export default getEncyclopediaSubcategoryBySlug
